import { HolidaysResource } from '~/resources';

export default {
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
    organizationTz: {
      type: String,
      default: 'UTC',
    },
    countryList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    saveButtonDisabled() {
      return this.saving || this.disableSaveButton;
    },
  },
  methods: {
    handleDisableSaveButton(value) {
      this.disableSaveButton = value;
    },
    async closeDialog(value) {
      if (value === 'back-to-previous-dialog') {
        this.showShiftOverlapConfirmationDialog = false;
        this.showDialog = true;
        await this.checkShiftOverlaps();

        return;
      }

      this.closeAllDialogs();
    },
    handleMembersUpdated(field, value) {
      switch (field) {
        case 'holiday_user_ids':
          if (this.membersListData) {
            this.membersListData = {};
          }
          this.holiday.holiday_user_ids = value;
          break;
        case 'members-list-data':
          this.membersListData = value;
          break;
        case 'membership_rules_countries':
          this.holiday.membership_rules.countries = value;
          break;
        case 'membership_rules_employment_types':
          this.holiday.membership_rules.employment_types = value;
          break;
      }

      this.checkShiftOverlaps();
    },
    handleHolidayUpdated(field, value) {
      this.$set(this.holiday, field, value);

      switch (field) {
        case 'members_added_via':
          this.overlapShiftCount = 0;
          break;
        case 'date':
          this.checkShiftOverlaps();
          break;
      }
    },
    checkShiftsForMembers() {
      const hasMembersListData = this.membersListData?.members?.length > 0;
      const selectAllOptionSelected = this.membersListData?.options?.select_all;
      const hasHolidayUserIds = this.holiday.holiday_user_ids?.length > 0;

      if (this.holiday.members_added_via === 'list' && this.membersListData?.members) {
        return this.holiday.date && (hasMembersListData || selectAllOptionSelected);
      }

      // If the holiday had members added through country and employment type (has membership rules).
      // We don't need to account for overlapping shifts.
      if (this.holiday.members_added_via === 'country_and_employment' || this.holiday.has_membership_rules) {
        return false;
      }

      return this.holiday.date && hasHolidayUserIds;
    },
    async checkShiftOverlaps() {
      this.overlapShiftError = false;

      if (this.checkShiftsForMembers()) {
        try {
          const params = { organizationId: this.organizationId };
          const payload = {
            user_ids: this.holiday.holiday_user_ids,
            members_data: this.membersListData ? this.membersListData : {},
            id: this.holiday.id ? this.holiday.id : null,
            date: moment(this.holiday.date).format('YYYY-MM-DD'),
          };
          const response = await HolidaysResource.shiftOverlaps(params, payload, { abortReload: true });

          if (response.shift_count !== undefined) {
            this.overlapShiftCount = response.shift_count;

            return this.overlapShiftCount > 0;
          }
          this.overlapShiftError = true;
        } catch (error) {
          this.overlapShiftError = true;
        }
      } else {
        this.overlapShiftCount = 0;
      }
    },
    async performHolidayAction(action) {
      const isValid = await this.$refs.dialogObserver.validate();

      if (isValid) {
        this.saving = true;
        const openShiftOverlapsDialog =
          this.holiday.members_added_via === 'country_and_employment' ? false : await this.checkShiftOverlaps();

        if (openShiftOverlapsDialog && !this.showShiftOverlapConfirmationDialog) {
          this.showDialog = false;
          this.showShiftOverlapConfirmationDialog = true;
          this.saving = false;

          return;
        }

        switch (action) {
          case 'create':
            await this.createHoliday();
            break;
          case 'update':
            await this.updateHoliday();
            break;
          case 'updateMembers':
            await this.updateHolidayMembers();
            break;
          default:
            break;
        }
      }
    },
  },
};
